enum EpisodeEvents {
  EpisodeSuggestedAuthorClick = 'EpisodeSuggestedAuthorClick'
};

export default EpisodeEvents;
